import { render, staticRenderFns } from "./EstablishmentYearSettingAdd.vue?vue&type=template&id=120b696f&scoped=true&"
import script from "./EstablishmentYearSettingAdd.vue?vue&type=script&lang=js&"
export * from "./EstablishmentYearSettingAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120b696f",
  null
  
)

export default component.exports